var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnWeb = function SvgIcnWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    alt: "website",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_web",
    transform: "translate(-2845 -6101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-globe",
    "data-name": "Icon ionic-ios-globe",
    d: "M8,1.688H7.979a6.313,6.313,0,0,0,0,12.625H8A6.313,6.313,0,1,0,8,1.688Zm5.469,5.888H11.114a11.951,11.951,0,0,0-.3-2.313,9.246,9.246,0,0,0,1.508-.637A5.437,5.437,0,0,1,13.469,7.575Zm-5.894,0H5.7a10.787,10.787,0,0,1,.267-2.1,9.234,9.234,0,0,0,1.609.215Zm0,.85V10.3a9.273,9.273,0,0,0-1.609.215A10.785,10.785,0,0,1,5.7,8.425Zm.85,0h1.86a10.723,10.723,0,0,1-.267,2.091A9.059,9.059,0,0,0,8.425,10.3Zm0-.85V5.694a9.273,9.273,0,0,0,1.593-.212,10.755,10.755,0,0,1,.267,2.094ZM11.745,4a8.431,8.431,0,0,1-1.153.47,6.266,6.266,0,0,0-.8-1.654A5.492,5.492,0,0,1,11.745,4Zm-1.955.689a8.542,8.542,0,0,1-1.366.182V2.64A3.677,3.677,0,0,1,9.791,4.686ZM7.575,2.628V4.865A8.394,8.394,0,0,1,6.194,4.68,3.675,3.675,0,0,1,7.575,2.628Zm-1.384.194a6.316,6.316,0,0,0-.8,1.642A8.621,8.621,0,0,1,4.255,4,5.41,5.41,0,0,1,6.191,2.823ZM3.675,4.628a9.063,9.063,0,0,0,1.493.631,11.469,11.469,0,0,0-.3,2.313H2.534A5.409,5.409,0,0,1,3.675,4.628Zm-1.144,3.8H4.868a11.92,11.92,0,0,0,.3,2.313,9.616,9.616,0,0,0-1.493.631A5.438,5.438,0,0,1,2.531,8.425ZM4.252,12a8.494,8.494,0,0,1,1.141-.467,6.338,6.338,0,0,0,.8,1.645A5.544,5.544,0,0,1,4.252,12Zm1.942-.686a8.438,8.438,0,0,1,1.381-.185v2.24A3.67,3.67,0,0,1,6.194,11.317ZM8.425,13.36V11.129a8.542,8.542,0,0,1,1.366.182A3.676,3.676,0,0,1,8.425,13.36Zm1.366-.173a6.266,6.266,0,0,0,.8-1.654,8.293,8.293,0,0,1,1.153.473A5.555,5.555,0,0,1,9.791,13.187Zm2.534-1.815a9.246,9.246,0,0,0-1.508-.637,11.889,11.889,0,0,0,.3-2.31h2.355A5.413,5.413,0,0,1,12.325,11.372Z",
    transform: "translate(2845.313 6101.313)",
    fill: "#787878",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 16,
    height: 16,
    transform: "translate(2845 6101)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_web.280479ad.svg";
export { ForwardRef as ReactComponent };